import React, { useState } from 'react';
import { signUp } from '../auth';
import { useNavigate, Link, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography, Alert, Link as MuiLink } from '@mui/material';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signUp({ username: email, password, options: { autoSignIn: true } });
      navigate(`/confirm-email?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setError(err.message || 'Registration failed');
      setLoading(false);
    }
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3 }}>
      <Typography variant="h5" mb={3}>{t('register.title')}</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TextField label={t('register.email')} type="email" fullWidth required
        value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} disabled={loading} />
      <TextField label={t('register.password')} type="password" fullWidth required
        value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 2 }} disabled={loading} />
      <FormControlLabel
        sx={{ mb: 2, alignItems: 'flex-start' }}
        control={
          <Checkbox
            checked={agreed}
            onChange={e => setAgreed(e.target.checked)}
            disabled={loading}
            sx={{ pt: 0 }}
          />
        }
        label={
          <Typography variant="body2">
            Я принимаю{' '}
            <MuiLink component={RouterLink} to="/agb">
              Оферту
            </MuiLink>
            {' '}и{' '}
            <MuiLink component={RouterLink} to="/gdpr">
              Политику конфиденциальности
            </MuiLink>
          </Typography>
        }
      />
      <Button type="submit" variant="contained" fullWidth disabled={loading || !agreed}>
        {loading ? t('register.submitting') : t('register.submit')}
      </Button>
      <Box sx={{ mt: 2 }}>
        <Link to="/login">{t('register.alreadyHaveAccount')}</Link>
      </Box>
    </Box>
  );
}
